
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Loginheader';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/FooterW';
import Policy from '../../components/PrivacyPolicy/privacypolicy';

const PrivacyPolicy = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Privacy Policy'} pagesub={'Home'} />
                    <Policy abClass={'pt-0'}/>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default PrivacyPolicy;